namespace Nobox.Administration {
    export interface TenantForm {
        Nm: Serenity.StringEditor;
        Id: Serenity.StringEditor;
        IsDlt: Serenity.IntegerEditor;
        Email: Serenity.StringEditor;
        Phone: Serenity.StringEditor;
        IdtryId: Serenity.ServiceLookupEditor;
        IdtryNm: Serenity.StringEditor;
        Level: TenantCountMemberEditor;
        SzId: Serenity.ServiceLookupEditor;
        SzNm: Serenity.StringEditor;
        InvCdGen: Serenity.StringEditor;
        Db: TenantDbEditor;
        ConStr: Serenity.StringEditor;
        Status: Serenity.EnumEditor;
        KetStatus: Serenity.TextAreaEditor;
        CtryId: Serenity.ServiceLookupEditor;
        StatesId: Serenity.ServiceLookupEditor;
        CityId: Serenity.ServiceLookupEditor;
        ZipCode: Serenity.StringEditor;
        Address: Serenity.StringEditor;
        Ctry: Serenity.StringEditor;
        States: Serenity.StringEditor;
        Note: Serenity.TextAreaEditor;
        TenantMembers: TenantMemberEditor;
        TenantIntegration: TenantIntegrationEditor;
        City: Serenity.StringEditor;
        AccountsGrid: Serenity.Extensions.StaticTextBlock;
    }

    export class TenantForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.Tenant';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TenantForm.init)  {
                TenantForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.ServiceLookupEditor;
                var w3 = TenantCountMemberEditor;
                var w4 = TenantDbEditor;
                var w5 = s.EnumEditor;
                var w6 = s.TextAreaEditor;
                var w7 = TenantMemberEditor;
                var w8 = TenantIntegrationEditor;
                var w9 = s.Extensions.StaticTextBlock;

                Q.initFormType(TenantForm, [
                    'Nm', w0,
                    'Id', w0,
                    'IsDlt', w1,
                    'Email', w0,
                    'Phone', w0,
                    'IdtryId', w2,
                    'IdtryNm', w0,
                    'Level', w3,
                    'SzId', w2,
                    'SzNm', w0,
                    'InvCdGen', w0,
                    'Db', w4,
                    'ConStr', w0,
                    'Status', w5,
                    'KetStatus', w6,
                    'CtryId', w2,
                    'StatesId', w2,
                    'CityId', w2,
                    'ZipCode', w0,
                    'Address', w0,
                    'Ctry', w0,
                    'States', w0,
                    'Note', w6,
                    'TenantMembers', w7,
                    'TenantIntegration', w8,
                    'City', w0,
                    'AccountsGrid', w9
                ]);
            }
        }
    }
}
